import React, { useEffect, lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { trackPage } from '../utilities/analyticsUtilities';
import { CircularProgress } from '@mui/material';
import { Navigate } from "react-router-dom";
import CreatePage from '../components/pages/CreatePage';
import ExportsPage from '../components/pages/ExportsPage';
import ProtectedAdminRoute from '../components/routes/ProtectedAdminRoute';
const PlanPage = lazy(() => import('../components/pages/PlanPage'));
const VideosPage = lazy(() => import('../components/pages/VideosPage'));
const NotFoundPage = lazy(() => import('../components/pages/NotFoundPage'));
const PasswordResetPage = lazy(() => import('../components/pages/PasswordResetPage'));
const PasswordChangePage = lazy(() => import('../components/pages/PasswordChangePage'));
const AccountPage = lazy(() => import('../components/pages/AccountPage'));
const PresetViewerPage = lazy(() => import('../components/pages/PresetViewerPage/PresetViewerPage'));
const EmailUnsubscribePage = lazy(() => import('../components/pages/EmailUnsubscribePage/EmailUnsubscribePage'));
const SupportPage = lazy(() => import('../components/pages/SupportPage/SupportPage'));
const EmailChangePage = lazy(() => import('../components/pages/EmailChangePage/EmailChangePage'));
const AdminUsersPage = lazy(() => import('../components/pages/Admin/UsersPage/UsersPage'));
const UserInfoPage = lazy(() => import('../components/pages/Admin/UserInfoPage/UserInfoPage'));
const UserVideosPage = lazy(() => import('../components/pages/Admin/UserVideosPage/UserVideosPage'));
const BillingPage = lazy(() => import('../components/pages/Admin/BillingPage/BillingPage'));
const PresetsPage = lazy(() => import('../components/pages/Admin/PresetsPage/PresetsPage'));
const ExportsQueuePage = lazy(() => import('../components/pages/Admin/ExportsQueuePage/ExportsQueuePage'));
const circularProgress = () => <CircularProgress size={80} />;

const AppRoutes = () => {
    const location = useLocation();

    useEffect(() => {
        trackPage(location.pathname);
    }, [location.pathname]);

    return (
        <Routes>
            <Route path='/' element={<Navigate to='/create' replace />} />

            <Route path='/exports/:videoId/:exportId?' element={<ExportsPage />} />

            <Route path='/create/:mod/:id' element={<CreatePage />} />

            <Route path='/create/:id' element={<CreatePage />} />

            <Route path='/create' element={<CreatePage />} />

            <Route path="preset/:id" element={
                <Suspense fallback={circularProgress()}>
                    <PresetViewerPage />
                </Suspense>
            } />

            <Route path="/videos" element={
                <Suspense fallback={circularProgress()}>
                    <VideosPage />
                </Suspense>
            } />

            <Route path="/plans" element={
                <Suspense fallback={circularProgress()}>
                    <PlanPage />
                </Suspense>
            } />

            <Route path="/plans/:mod/:id/:price?" element={
                <Suspense fallback={circularProgress()}>
                    <PlanPage />
                </Suspense>
            } />

            <Route path='/not-found' element={<NotFoundPage />} />

            <Route path="/admin/users" element={
                <ProtectedAdminRoute>
                    <Suspense fallback={circularProgress()}>
                        <AdminUsersPage />
                    </Suspense>
                </ProtectedAdminRoute>
            } />

            <Route path="/admin/users/:userId" element={
                <ProtectedAdminRoute>
                    <Suspense fallback={circularProgress()}>
                        <UserInfoPage />
                    </Suspense>
                </ProtectedAdminRoute>
            } />

            <Route path="/admin/users/:userId/billing" element={
                <ProtectedAdminRoute>
                    <Suspense fallback={circularProgress()}>
                        <BillingPage />
                    </Suspense>
                </ProtectedAdminRoute>
            } />

            <Route path="/admin/users/:userId/videos" element={
                <ProtectedAdminRoute>
                    <Suspense fallback={circularProgress()}>
                        <UserVideosPage />
                    </Suspense>
                </ProtectedAdminRoute>
            } />

            <Route path="/admin/presets" element={
                <ProtectedAdminRoute>
                    <Suspense fallback={circularProgress()}>
                        <PresetsPage />
                    </Suspense>
                </ProtectedAdminRoute>
            } />

            <Route path="/admin/exports" element={
                <ProtectedAdminRoute>
                    <Suspense fallback={circularProgress()}>
                        <ExportsQueuePage />
                    </Suspense>
                </ProtectedAdminRoute>
            } />

            <Route path="/account" element={
                <Suspense fallback={circularProgress()}>
                    <AccountPage />
                </Suspense>
            } />

            <Route path="/support" element={
                <Suspense fallback={circularProgress()}>
                    <SupportPage />
                </Suspense>
            } />

            <Route path="/password-change" element={
                <Suspense fallback={circularProgress()}>
                    <PasswordChangePage />
                </Suspense>
            } />

            <Route path="/password-reset" element={
                <Suspense fallback={circularProgress()}>
                    <PasswordResetPage />
                </Suspense>
            } />

            <Route path="/email-change" element={
                <Suspense fallback={circularProgress()}>
                    <EmailChangePage />
                </Suspense>
            } />

            <Route path="/unsubscribe" element={
                <Suspense fallback={circularProgress()}>
                    <EmailUnsubscribePage />
                </Suspense>
            } />

            <Route path='*' element={<Navigate to='/not-found' replace />} />
        </Routes>
    );
}

export default AppRoutes;